import styled from 'styled-components';

export const AppContainer = styled.div`
  min-height: calc(100vh - 250px) !important;
`;
